import { Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import AccountBalance from '@material-ui/icons/AccountBalance';
import RemoveIcon from '@material-ui/icons/Remove';
import { Button, MdSpace, Section, SmSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import ParticipanteAutoComplete from 'components/participante/participanteAutoComplete';
import { AddCircle } from '@material-ui/icons';
import {
  BancoResponse,
  CriteriosRemuneracao,
  Custodiante,
  EmissaoStatus,
  CriteriosRemuneracaoField,
  FuncaoParticipante,
  InformacoesBancariasCustodiante,
  InvestidorPrivado,
  InvestidorResponse,
  ParticipanteResponse,
  StatusInteroperabilidade,
  InstrumentoFinanceiro,
} from 'common/genericTypes';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import InvestidoresAddDrawer from 'components/investidoresDrawer/investidoresAddDrawer';
import InvestidoresListDrawer from 'components/investidoresDrawer/investidoresListDrawer';
import InformacoesBancariasAddDrawer from 'components/informacoesBancariasDrawer/informacoesBancariasAddDrawer';
import InformacoesBancariasListDrawer from 'components/informacoesBancariasDrawer/informacoesBancariasListDrawer';

interface Props {
  valorUnitario: number;
  quantidadeTotal: number;
  custodiantesProps: Array<Custodiante>;
  instrumentoFinanceiroStatus?: string;
  criteriosRemuneracao: CriteriosRemuneracao,
  updateField: (field: CriteriosRemuneracaoField) => void;
  statusEmissao: EmissaoStatus;
  bancos: Array<BancoResponse>;
  custodiantes: Array<ParticipanteResponse>;
  tipoInstrumento?: InstrumentoFinanceiro;
}

const InvestidoresSection: React.FC<Props> = (props) => {
  const {
    valorUnitario,
    quantidadeTotal,
    custodiantesProps,
    instrumentoFinanceiroStatus,
    criteriosRemuneracao,
    updateField,
    statusEmissao,
    bancos,
    custodiantes,
    tipoInstrumento,
  } = props;

  const participanteLogado = useSelector((state: RootState) => state.auth.usuario.participante);
  const isParticipanteCustodiante = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante
  );

  const [addedCustodiantes, setAddedCustodiantes] = useState<Array<Custodiante>>([...custodiantesProps]);
  const [addedCustodiantesAUX, setAddedCustodiantesAUX] = useState<Array<Custodiante> | null>(null);
  const [selectedCustodiante, setSelectedCustodiante] = useState<ParticipanteResponse | null>(null);

  const [openDrawerAdicionar, setOpenDrawerAdicionar] = useState<boolean>(false);
  const [openDrawerLista, setOpenDrawerLista] = useState<boolean>(false);
  const [investidoresOptions, setInvestidoresOptions] = useState<Array<InvestidorResponse>>([]);
  const [openInformacoesBancariasDrawer, setOpenInformacoesBancariasDrawer] = useState<boolean>(false);
  const [openInformacoesBancariasListDrawer, setOpenInformacoesBancariasListDrawer] = useState<boolean>(false);
  const [isEditInformacoesBancarias, setIsEditInformacoesBancarias] = useState<boolean>(false);

  const [currentCustodiante, setCurrentCustodiante] = useState<Custodiante | null>(
    isParticipanteCustodiante
      ? ({
        custodianteId: participanteLogado.id,
        cnpjInstituicaoCustodiante: participanteLogado.cnpj,
        razaoSocialInstituicaoCustodiante: participanteLogado.razaoSocial,
        investidoresPrivados:
          custodiantesProps.length > 0
            ? custodiantesProps.find((c) => participanteLogado.id === c.custodianteId)
              ?.investidoresPrivados
            : [],
        informacoesBancarias:
          custodiantesProps.length > 0
            ? custodiantesProps.find((c) => participanteLogado.id === c.custodianteId)
              ?.informacoesBancarias
            : null,
      } as Custodiante)
      : null
  );
  const divStyles = () => {
    if (canEdit) {
      return { borderTop: '1px solid #e0e0e0', marginBottom: '20px', paddingTop: '30px' };
    }
    return;
  };
  const dispatch = useDispatch();
  const isParticipanteCredenciado = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Credenciado
  );
  const isParticipanteEmissor = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Emissor
  );
  const getInvestidoresApi = useSelector((state: RootState) => state.investidorApi.getInvestidores);
  const canEdit = !(statusEmissao === EmissaoStatus.Emitido || statusEmissao === EmissaoStatus.ParcialmenteEmitido || instrumentoFinanceiroStatus === StatusInteroperabilidade.Aprovado);
  const label = 'Custodiantes';

  const getInvestidores = useCallback(async (custodianteId) => {
    try {
      const result = await getInvestidoresApi(dispatch, { participanteId: custodianteId.replace(/[^a-zA-Z0-9]/g, '') }, true);
      setInvestidoresOptions(result);
    } catch (error) { }
  }, []);

  const handleSelectedCustodianteChange = (value: ParticipanteResponse | null) => {
    setSelectedCustodiante(value);
  };

  const handleAddClick = () => {
    if (
      selectedCustodiante != null &&
      !addedCustodiantes.find((custodiante) => custodiante.custodianteId === selectedCustodiante.id)
    ) {
      const newCustodianteList = [
        ...addedCustodiantes,
        {
          custodianteId: selectedCustodiante.id,
          cnpjInstituicaoCustodiante: selectedCustodiante.cnpj,
          razaoSocialInstituicaoCustodiante: selectedCustodiante.razaoSocial,
          investidoresPrivados: [],
          informacoesBancarias: [],
        } as Custodiante,
      ];
      setAddedCustodiantes([...newCustodianteList]);
      setAddedCustodiantesAUX([...newCustodianteList]);
      setSelectedCustodiante(null);
      handleOpenInformacoesBancariasDrawer({
        custodianteId: selectedCustodiante.id,
        cnpjInstituicaoCustodiante: selectedCustodiante.cnpj,
        razaoSocialInstituicaoCustodiante: selectedCustodiante.razaoSocial,
        investidoresPrivados: [] as InvestidorPrivado[],
        informacoesBancarias: [] as InformacoesBancariasCustodiante[]
      }, false)
    }
  };

  const handleRemoveClick = (custodianteId: string) => {
    setAddedCustodiantes([...addedCustodiantes.filter((custodiante) => custodiante.custodianteId !== custodianteId)]);
    setAddedCustodiantesAUX([...addedCustodiantes.filter((custodiante) => custodiante.custodianteId !== custodianteId)]);
  };

  const handleOpenInvestidoresDrawer = (custodiante: Custodiante) => {
    getInvestidores(custodiante.custodianteId);
    setCurrentCustodiante(custodiante);
    setOpenDrawerAdicionar(true);
  };

  const handleCloseInvestidoresDrawer = () => {
    setOpenDrawerAdicionar(false);
  };

  const handleOpenInformacoesBancariasDrawer = (custodiante: Custodiante, isEdit: boolean) => {
    getInvestidores(custodiante.custodianteId);
    setCurrentCustodiante(custodiante);
    setOpenInformacoesBancariasListDrawer(false);
    setOpenInformacoesBancariasDrawer(true);
    setIsEditInformacoesBancarias(isEdit);
  };

  const handleCloseInformacoesBancariasDrawer = () => {
    setOpenInformacoesBancariasDrawer(false);
  };

  const handleAddInvestidor = (value: InvestidorPrivado) => {
    setOpenInformacoesBancariasListDrawer(false);
    let updatedCustodiantes = null;
    if (isParticipanteCustodiante) {
      updatedCustodiantes = JSON.parse(JSON.stringify(currentCustodiante));

      updatedCustodiantes.investidoresPrivados = [...updatedCustodiantes.investidoresPrivados, value];
      setAddedCustodiantes([updatedCustodiantes]);
      setAddedCustodiantesAUX([updatedCustodiantes]);
      setCurrentCustodiante(updatedCustodiantes);
    } else {
      updatedCustodiantes = JSON.parse(JSON.stringify(addedCustodiantes));

      const custodianteIndex = updatedCustodiantes.findIndex(
        (custodiante: Custodiante) =>
          custodiante.custodianteId === currentCustodiante?.custodianteId
      );
      if (custodianteIndex !== -1) {
        updatedCustodiantes[custodianteIndex].investidoresPrivados = [
          ...updatedCustodiantes[custodianteIndex].investidoresPrivados,
          value,
        ];
      }
      setAddedCustodiantes([...updatedCustodiantes]);
      setAddedCustodiantesAUX([...updatedCustodiantes]);
    }
  };

  const handleAddinformacoesBancarias = async (value: InformacoesBancariasCustodiante, isEdit: boolean) => {
    let updatedCustodiantes: any = null
    if (isParticipanteCustodiante) {
      updatedCustodiantes = JSON.parse(JSON.stringify(currentCustodiante));

      if (isEdit && currentCustodiante) {
        handleUpdateInformacoesBancarias(value);
      } else {
        updatedCustodiantes.informacoesBancarias = [...updatedCustodiantes.informacoesBancarias, value];
        setAddedCustodiantes([...updatedCustodiantes]);
        setAddedCustodiantesAUX([...updatedCustodiantes]);
        setCurrentCustodiante(updatedCustodiantes);
      }
    } else {
      updatedCustodiantes = JSON.parse(JSON.stringify(addedCustodiantes));
      const custodianteIndex = updatedCustodiantes.findIndex(
        (custodiante: Custodiante) =>
          custodiante.cnpjInstituicaoCustodiante === currentCustodiante?.cnpjInstituicaoCustodiante
      );

      if (isEdit && currentCustodiante) {
        handleUpdateInformacoesBancarias(value);
      } else {
        if (custodianteIndex !== -1) {
          updatedCustodiantes[custodianteIndex].informacoesBancarias.shift()
          updatedCustodiantes[custodianteIndex].informacoesBancarias = [
            ...updatedCustodiantes[custodianteIndex].informacoesBancarias,
            value,
          ];
        }
        setAddedCustodiantes([...updatedCustodiantes]);
        setAddedCustodiantesAUX([...updatedCustodiantes]);
      }
    }
  };

  const handleRemoveInvestidor = (cpfCnpj: string) => {
    const updatedInvestidores = JSON.parse(JSON.stringify(currentCustodiante?.investidoresPrivados));
    const investidorIndex = updatedInvestidores.findIndex(
      (investidor: InvestidorPrivado) => investidor.cpfCnpj === cpfCnpj
    );
    if (investidorIndex !== -1) {
      updatedInvestidores.splice(investidorIndex, 1);
      const custodianteIndex = addedCustodiantes.findIndex(
        (custodiante: Custodiante) =>
          custodiante.cnpjInstituicaoCustodiante === currentCustodiante?.cnpjInstituicaoCustodiante
      );
      const listCustodianteToUpdate = [...addedCustodiantes];
      const custodianteToUpdate = {
        custodianteId: currentCustodiante?.custodianteId,
        cnpjInstituicaoCustodiante: currentCustodiante?.cnpjInstituicaoCustodiante ?? '',
        razaoSocialInstituicaoCustodiante: currentCustodiante?.razaoSocialInstituicaoCustodiante ?? '',
        investidoresPrivados: updatedInvestidores ?? [],
        informacoesBancarias: currentCustodiante?.informacoesBancarias ?? [],
      } as Custodiante;
      listCustodianteToUpdate.splice(custodianteIndex, 1, custodianteToUpdate);
      setAddedCustodiantes([...listCustodianteToUpdate]);
      setAddedCustodiantesAUX([...listCustodianteToUpdate]);
      setCurrentCustodiante(custodianteToUpdate);
    }
  };

  const handleUpdateInformacoesBancarias = (informacoesBancarias?: InformacoesBancariasCustodiante) => {
    const custodianteIndex = addedCustodiantes.findIndex(
      (custodiante: Custodiante) =>
        custodiante.cnpjInstituicaoCustodiante === currentCustodiante?.cnpjInstituicaoCustodiante
    );
    const listCustodianteToUpdate = [...addedCustodiantes];

    let dadosBancarios: InformacoesBancariasCustodiante[] = [];
    if (informacoesBancarias) {
      dadosBancarios.push(informacoesBancarias);
    }

    const custodianteToDeleteDadosBancarios = {
      custodianteId: currentCustodiante?.custodianteId,
      cnpjInstituicaoCustodiante: currentCustodiante?.cnpjInstituicaoCustodiante ?? '',
      razaoSocialInstituicaoCustodiante: currentCustodiante?.razaoSocialInstituicaoCustodiante ?? '',
      informacoesBancarias: dadosBancarios,
      investidoresPrivados: currentCustodiante?.investidoresPrivados ?? [],
    } as Custodiante;

    listCustodianteToUpdate.splice(custodianteIndex, 1, custodianteToDeleteDadosBancarios);

    setCurrentCustodiante(custodianteToDeleteDadosBancarios);
    setAddedCustodiantes([...listCustodianteToUpdate]);
    setAddedCustodiantesAUX([...listCustodianteToUpdate]);
  };

  const handleOpenInvestidoresListDrawer = (custodiante: Custodiante) => {
    setCurrentCustodiante(custodiante);
    setOpenDrawerLista(true);
  };

  const handleCloseInvestidoresListDrawer = () => {
    setOpenDrawerLista(false);
  };

  const handleOpenInformacoesBancariasListDrawer = (custodiante: Custodiante) => {
    setCurrentCustodiante(custodiante);
    setOpenInformacoesBancariasListDrawer(true);
  };

  const handleCloseInformacoesBancariasListDrawer = () => {
    setOpenInformacoesBancariasListDrawer(false);
  };

  useEffect(() => {
    if (addedCustodiantesAUX !== null) {
      dispatch(updateField({ name: 'custodiantes', value: addedCustodiantesAUX }));
    }
  }, [addedCustodiantesAUX]);

  useEffect(() => {
    if (!openDrawerAdicionar && !openDrawerLista && !isParticipanteCustodiante) {
      setCurrentCustodiante(null);
    }
  }, [openDrawerAdicionar, openDrawerLista]);

  useEffect(() => {
    if (criteriosRemuneracao.custodiantes === null || criteriosRemuneracao.custodiantes.length === 0) {
      setAddedCustodiantes([]);
      return;
    } else {
      setAddedCustodiantes(criteriosRemuneracao.custodiantes);
    }
  }, [criteriosRemuneracao.custodiantes]);

  return (
    <>
      <Section title={'Investidores'}>
        <Grid container style={{ display: 'flex', flexDirection: 'column' }}>
          {!isParticipanteCustodiante && (
            <>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Grid item xs={10}>
                  <ParticipanteAutoComplete
                    label={label}
                    participantes={custodiantes}
                    participante={selectedCustodiante}
                    onChange={handleSelectedCustodianteChange}
                    error={undefined}
                  />
                </Grid>
                <Button
                  variant="contained"
                  color={
                    selectedCustodiante &&
                      !addedCustodiantes.find(
                        (custodiante) => custodiante.cnpjInstituicaoCustodiante === selectedCustodiante.cnpj
                      )
                      ? 'primary'
                      : 'default'
                  }
                  style={{ minWidth: '0', padding: '5px', width: '45px', height: '45px', marginLeft: 'auto' }}
                  onClick={handleAddClick}
                >
                  <AddIcon />
                </Button>
              </Grid>
              <MdSpace />
            </>
          )}
          {!isParticipanteCustodiante ? (
            addedCustodiantes?.map((custodiante, index) => (
              <>
                <div style={divStyles()}>
                  <Grid
                    container
                    key={index}
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Grid item xs={12}>
                      <Grid
                        item
                        xs={12}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                      >
                        <Grid item xs={10}>
                          <ParticipanteAutoComplete
                            label={label}
                            participantes={custodiantes}
                            participante={
                              {
                                id: custodiante.custodianteId,
                                razaoSocial: custodiante.razaoSocialInstituicaoCustodiante,
                                cnpj: custodiante.cnpjInstituicaoCustodiante,
                              } as ParticipanteResponse
                            }
                            onChange={handleSelectedCustodianteChange}
                            disabled={true}
                          />
                        </Grid>
                        {!isParticipanteCustodiante ? (
                          <Button
                            variant="contained"
                            color="error"
                            style={{ minWidth: '0', padding: '5px', width: '45px', height: '45px', marginLeft: 'auto' }}
                            onClick={() => {
                              handleRemoveClick(custodiante.custodianteId);
                            }}
                          >
                            <RemoveIcon />
                          </Button>
                        ) : null}
                      </Grid>
                      {!isParticipanteEmissor && !isParticipanteCredenciado && (
                        <>
                          <SmSpace />
                          <Grid
                            item
                            xs={12}
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                            }}
                          >
                            {(
                              <Grid item xs={3} style={{ marginRight: '10px' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  startIcon={<AddCircle />}
                                  onClick={() => handleOpenInvestidoresDrawer(custodiante)}
                                  disabled={false}
                                  style={{ width: '100%' }}
                                >
                                  {'Adicionar Investidor'}
                                </Button>
                              </Grid>
                            )}
                            <Grid item xs={3} style={{ marginRight: '10px' }}>
                              <Button
                                variant="contained"
                                color="default"
                                size="small"
                                startIcon={<FormatListBulletedIcon />}
                                onClick={() => handleOpenInvestidoresListDrawer(custodiante)}
                                disabled={false}
                                style={{ width: '100%' }}
                              >
                                {'Investidores'}
                              </Button>
                            </Grid>
                            {
                              <Grid item xs={3}>
                                <Button
                                  variant="contained"
                                  color="default"
                                  size="small"
                                  startIcon={<AccountBalance />}
                                  onClick={() => handleOpenInformacoesBancariasListDrawer(custodiante)}
                                  disabled={false}
                                  style={{ width: '100%' }}
                                >
                                  {'Dados Bancários do Custodiante'}
                                </Button>
                              </Grid>}

                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Grid>
                </div>
                <MdSpace />
              </>
            ))
          ) : (
            <>
              <Grid item xs={10}>
                <ParticipanteAutoComplete
                  label={label}
                  participantes={custodiantes}
                  participante={
                    {
                      razaoSocial: participanteLogado.razaoSocial,
                      cnpj: participanteLogado.cnpj,
                    } as ParticipanteResponse
                  }
                  onChange={() => { }}
                  disabled={true}
                />
              </Grid>
              <SmSpace />
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                  <Grid item xs={5} style={{ marginRight: '10px' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<AddCircle />}
                      onClick={
                        currentCustodiante != null ? () => handleOpenInvestidoresDrawer(currentCustodiante) : () => { }
                      }
                      disabled={false}
                      style={{ width: '100%' }}
                    >
                      {'Adicionar Investidor'}
                    </Button>
                  </Grid>
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    color="default"
                    size="small"
                    startIcon={<FormatListBulletedIcon />}
                    onClick={
                      currentCustodiante != null ? () => handleOpenInvestidoresListDrawer(currentCustodiante) : () => { }
                    }
                    disabled={false}
                    style={{ width: '100%' }}
                  >
                    {'Investidores'}
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Section>
      <InvestidoresAddDrawer
        custodianteRazaoSocial={currentCustodiante?.razaoSocialInstituicaoCustodiante}
        investidores={currentCustodiante?.investidoresPrivados ?? []}
        investidoresOptions={investidoresOptions}
        bancosOptions={bancos}
        addInvestidor={handleAddInvestidor}
        quantidadeDisponivel={
          quantidadeTotal -
          addedCustodiantes.reduce(
            (qtdTotal, custodiante) =>
              qtdTotal +
              custodiante.investidoresPrivados.reduce(
                (qtdCustodiante, investidor) => qtdCustodiante + investidor.quantidade,
                0
              ),
            0
          )
        }
        valorUnitario={valorUnitario}
        open={openDrawerAdicionar}
        onClose={handleCloseInvestidoresDrawer}
        tipoInstrumento={tipoInstrumento}
      />
      <InvestidoresListDrawer
        open={openDrawerLista}
        custodiante={currentCustodiante}
        onClose={handleCloseInvestidoresListDrawer}
        removeInvestidor={handleRemoveInvestidor}
        isEdit={canEdit}
      />
      <InformacoesBancariasAddDrawer
        custodianteRazaoSocial={currentCustodiante?.razaoSocialInstituicaoCustodiante}
        bancosOptions={bancos}
        open={openInformacoesBancariasDrawer}
        isEdit={isEditInformacoesBancarias}
        onClose={handleCloseInformacoesBancariasDrawer}
        addinformacoesBancarias={handleAddinformacoesBancarias}
      />
      <InformacoesBancariasListDrawer
        open={openInformacoesBancariasListDrawer}
        custodiante={currentCustodiante}
        onClose={handleCloseInformacoesBancariasListDrawer}
        removeDadosBancarios={handleUpdateInformacoesBancarias}
        isEdit={canEdit}
        dadosBancarios={handleOpenInformacoesBancariasDrawer}
      />
    </>
  );
};

export default InvestidoresSection;